// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountActivateUserDefaultResponse {
    static getAttributeTypeMap() {
        return AccountActivateUserDefaultResponse.attributeTypeMap;
    }
}
AccountActivateUserDefaultResponse.discriminator = undefined;
AccountActivateUserDefaultResponse.additionalProperties = false;
AccountActivateUserDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=accountActivateUserDefaultResponse.js.map